export default "__VITE_ASSET__C7QJ1q$U__"